import { useEffect } from "react";

const BRAND = "Reel Funny Goods";
const DEFAULT_DESC = "Funny fishing shirts, hoodies, mugs and home goods for anglers who never take the bait too seriously.";

function setMeta(selector, attr, key, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attr === "rel" ? "link" : "meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute(attr === "rel" ? "href" : "content", value);
}

export const clip = (s, n = 155) => {
  const t = (s || "").replace(/<(table|style|script)\b[\s\S]*?<\/\1>/gi, " ").replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/\s+/g, " ").trim();
  return t.length <= n ? t : `${t.slice(0, n - 1).replace(/\s+\S*$/, "")}…`;
};

export default function usePageMeta({ title, description, path, noindex = false }) {
  useEffect(() => {
    if (!title) return;
    document.title = title.includes(BRAND) ? title : `${title} | ${BRAND}`;
    const desc = clip(description) || DEFAULT_DESC;
    setMeta('meta[name="description"]', "name", "description", desc);
    setMeta('meta[property="og:title"]', "property", "og:title", document.title);
    setMeta('meta[property="og:description"]', "property", "og:description", desc);
    setMeta('link[rel="canonical"]', "rel", "canonical", `${window.location.origin}${path ?? window.location.pathname}`);
    setMeta('meta[name="robots"]', "name", "robots", noindex ? "noindex, nofollow" : "index, follow");
  }, [title, description, path, noindex]);
}
